import { useEffect } from 'react';

declare global {
  interface Window {
    searchBar: (options: {
      baseUrl: string;
      showLocation: boolean;
      color: string;
      rounded: boolean;
      openInNewTab: boolean;
      font: string;
    }) => void;
  }
}

export default function Hero() {
  const scrollToListings = () => {
    const element = document.getElementById('listings');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    const init = () => {
      if (typeof window.searchBar === 'function') {
        window.searchBar({
          baseUrl: 'https://71910_1.holidayfuture.com/',
          showLocation: true,
          color: '#cc2dcf',
          rounded: true,
          openInNewTab: true,
          font: 'Open Sans',
        });
      } else {
        setTimeout(init, 300);
      }
    };
    init();
  }, []);

  return (
    <section className="relative min-h-screen w-full flex items-center justify-center overflow-x-hidden">
      <div className="absolute inset-0">
        <img
          src="https://a0.muscache.com/im/pictures/miso/Hosting-889843382811703189/original/d9f61d52-56a6-4e25-b17e-53960e86395e.jpeg"
          alt="Austin bachelor party house with resort pool and luxury amenities"
          className="w-full h-full object-cover object-center"
          fetchPriority="high"
          loading="eager"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 text-center px-6 w-full max-w-5xl mx-auto py-28 md:py-20">
        <span className="inline-block bg-teal-500/80 text-white text-xs md:text-sm font-semibold px-4 py-1.5 rounded-full mb-4 md:mb-5 tracking-wide uppercase">
          Austin's #1 Bachelor &amp; Bachelorette Party House
        </span>
        <h1 className="text-4xl md:text-7xl font-bold text-white mb-4 md:mb-6 leading-tight">
          The Ultimate Austin <br className="hidden md:block" /> Party House Rental
        </h1>
        <p className="text-base md:text-2xl text-white/95 mb-6 md:mb-10 max-w-3xl mx-auto leading-relaxed">
          Resort pool, hot tub, karaoke, game room &amp; sports courts — private luxury estates in Austin, Texas perfect for <strong>bachelor parties</strong> and <strong>bachelorette parties</strong> of 12–22 guests
        </p>

        {/* Hostaway Booking Search Widget */}
        <div className="mb-6 md:mb-8 w-full max-w-3xl mx-auto">
          <div id="hostaway-booking-widget"></div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={scrollToListings}
            className="bg-teal-500 text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-teal-600 transition-all transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer w-full sm:w-auto"
          >
            View Party Houses
          </button>
          <button
            onClick={() => {
              window.open('https://71910_1.holidayfuture.com/', '_blank');
            }}
            className="bg-white/10 backdrop-blur-sm text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-white/20 transition-all border-2 border-white/50 whitespace-nowrap cursor-pointer w-full sm:w-auto"
          >
            Book Your Dates
          </button>
        </div>
      </div>

      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce hidden md:block">
        <button
          onClick={scrollToListings}
          className="text-white cursor-pointer"
          aria-label="Scroll down"
        >
          <i className="ri-arrow-down-line text-4xl"></i>
        </button>
      </div>
    </section>
  );
}
